import Vue from "vue";
import Vuex from "vuex";

import rematricula from "./rematricula";
import alteracaoMatricula from "./alteracaoMatricula";
import atendimento from "./atendimento";
import colegio from "./colegio";
import menu from "./menu";
import biblioteca from "./biblioteca";
import graduacao from "./graduacao";
import * as Sentry from "@sentry/browser";
import Endereco from "../domain/cep/Endereco";

Vue.use(Vuex);

const DEFAULT_LOGO = "/static/images/ci.png";
const logoPorColigada = {
  1: "/static/images/ci.png",
  3: "/static/images/faculdade-neg.png"
};

const getLogoByColigada = coligada =>
  (coligada && logoPorColigada[Number(coligada)]) || DEFAULT_LOGO;

const isSupported = () => {
  try {
    const key = "__some_random_key_you_are_not_going_to_use__";
    localStorage.setItem(key, key);
    localStorage.removeItem(key);
    return true;
  } catch (e) {
    return false;
  }
};

function initialState() {
  return {
    qtdDisciplinas: 1,
    token: null,
    refreshToken: null,
    usuario: {},
    ambientes: {},
    acessoVerificado: false,
    lembrar: true,
    logo: "/static/images/logo-integrado.png",
    crm: {
      conjuge: false
    },
    endereco: new Endereco(),
    infoPage: {
      title: "",
      description: "",
      button: {}
    }
  };
}

const mutations = {
  updateToken(state, token) {
    state.token = token;
  },
  updateRefreshToken(state, refreshToken) {
    state.refreshToken = refreshToken;
  },
  updateEndereco(state, endereco) {
    state.endereco = endereco;
  },
  updateUsuario(state, usuario) {
    state.usuario = usuario;

    if (process.env.NODE_ENV === "production" && usuario && usuario.id) {
      Sentry.setUser({
        id: usuario.id,
        username: usuario.nome,
        email: usuario.email
      });

      Sentry.setContext("usuario", {
        login: usuario.login,
        tipo: usuario.tipo
      });
    }
  },
  updateConjuge(state, conjuge) {
    state.crm.conjuge = conjuge;
  },
  updateAcessoVerificado(state, acessoVerificado) {
    state.acessoVerificado = acessoVerificado;
  },
  updateLembrar(state, lembrar) {
    state.lembrar = lembrar;
  },
  updateLogo(state, logo) {
    state.logo = logo;
  },
  updateAmbientes(state, ambientes) {
    state.ambientes = ambientes;
  },
  updateInfoPage(state, infoPage) {
    state.infoPage = infoPage;
  },
  clearStorage(state) {
    const s = initialState();

    Object.keys(s).forEach(key => {
      state[key] = s[key];
    });
  },
  initialiseStore(state) {
    if (!isSupported()) {
      return;
    }

    if (localStorage.getItem("store")) {
      this.replaceState(
        Object.assign(state, JSON.parse(localStorage.getItem("store")))
      );
    }
  }
};

const actions = {
  setToken(state, token) {
    state.commit("updateToken", token);
  },
  setRefreshToken(state, refreshToken) {
    state.commit("updateRefreshToken", refreshToken);
  },
  setUsuario(state, usuario) {
    state.commit("updateUsuario", usuario);
  },
  setConjuge(state, conjuge) {
    state.commit("updateConjuge", conjuge);
  },
  setEndereco(state, endereco) {
    state.commit("updateEndereco", endereco);
  },
  setAcessoVerificado(state, acessoVerificado) {
    state.commit("updateAcessoVerificado", acessoVerificado);
  },
  setLembrar(state, lembrar) {
    state.commit("updateLembrar", lembrar);
  },
  setLogo(state, logo) {
    state.commit("updateLogo", logo);
  },
  setLogoPorColigada(state, coligada) {
    state.commit("updateLogo", getLogoByColigada(coligada));
  },
  setAmbientes(state, ambientes) {
    state.commit("updateAmbientes", ambientes);
  },
  setInfoPage(state, infoPage) {
    state.commit("updateInfoPage", infoPage);
  },
  clearStorage(state) {
    state.commit("clearStorage");
    state.commit("rematricula/clearStorage");
    state.commit("alteracaoMatricula/clearStorage");
  }
};

const store = new Vuex.Store({
  state: initialState(),
  actions,
  mutations,
  modules: {
    alteracaoMatricula,
    rematricula,
    colegio,
    menu,
    biblioteca,
    atendimento,
    graduacao
  }
});

store.subscribe((mutation, state) => {
  const badMutations = ["updateEndereco", "updateConjuge"];

  if (!isSupported()) {
    return;
  }

  if (badMutations.indexOf(mutation.type) === -1) {
    localStorage.setItem("store", JSON.stringify(state));
  }
});

export default store;



// WEBPACK FOOTER //
// ./src/store/store.js